const { arrayOf, string, bool, shape } = require('prop-types');
const phoneSpec = require('./phone.spec');

module.exports = {
  active: bool,
  queryType: string,
  queryValue: string,
  alias: string,
  code: string,
  name: string,
  isPinOn: bool,
  phones: shape(phoneSpec),
  tags: shape({
    inclusions: arrayOf(string.isRequired),
    exclusions: arrayOf(string.isRequired),
  }),
  landingPage: string,
  cid: string,
};
